import { CameraPlus, ClockBack, Question, Table } from '@factorialco/f0-react/icons/app'

export default function (id: string) {
  if (/_traceability$/.test(id)) return Table
  if (/_snapshot$/.test(id)) return ClockBack
  if (/_current$/.test(id)) return CameraPlus
  return Question
}
